import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useAlwaysShowExpensiveLiveShippingQuotesExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AlwaysShowExpensiveLiveShippingQuotes,
        AmplitudeVariants.AlwaysShowExpensiveLiveShippingQuotes.AlwaysShowExpensiveQuotes
    );
